<script>
import mixin from "@/pages/inspection_reports/forms/mixin";

export default {
	mixins: [mixin],
	methods: {
    isWithinMargin(testValue, inputValueLeft, inputValueRight) {
      if(!inputValueLeft || !inputValueRight) {
        return false;
      }

      let leftDifference = Math.abs(inputValueLeft - testValue).toFixed(4);
      let rightDifference = Math.abs(inputValueRight - testValue).toFixed(4);
      let margin = testValue / 100 * 4;
      if(testValue <= 250) {
        margin = 10;
      }

      let leftIsCorrect = leftDifference <= margin;
      let rightIsCorrect = rightDifference <= margin;

      let differenceBetweenLeftAndRight = Math.abs(inputValueLeft - inputValueRight).toFixed(4);

      margin = testValue / 100 * 2;
      if(testValue <= 250) {
        margin = 5;
      }

      let differenceIsCorrect = differenceBetweenLeftAndRight <= margin;

      return leftIsCorrect && rightIsCorrect && differenceIsCorrect;
    },
		getGroups() {
			return [
				{
          'title': 'Algemene gegevens',
					'name': 'product',
					'component': 'default',
					'values': {
						'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
						'product_type': this.input({type: 'Default', label: 'Type', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
						'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
						'product_meetbereik': this.input({type: 'Default', label: 'Meetbereik', value: this.getValue('product_meetbereik', '0 - 1.00 daN')}),
					}
				},
				{
					'title': 'Plaats van opstelling',
					'name': 'customer',
          'component': 'hidden',
					'values': {
						'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
						'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
						'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
					}
				},
				{
					'title': 'Conformiteit',
					'name': 'conformiteit',
					'component': 'default',
					'values': {
						'conformiteit_verzegeling_onbeschadigd': this.input({type: 'YesNo', label: 'Verzegeling onbeschadigd', value: this.getValue('conformiteit_verzegeling_onbeschadigd')}),
						'conformiteit_typekeuringscert': this.input({type: 'YesNo', label: 'Typekeuringscert. met bijlage + doc. aanw.', value: this.getValue('conformiteit_typekeuringscert')}),
						'conformiteit_aanwezige_printplaten': this.input({type: 'YesNo', label: 'Aanwezige printplaten en voedingsunit', value: this.getValue('conformiteit_aanwezige_printplaten')}),
						'conformiteit_krachtopnemers': this.input({type: 'YesNo', label: 'Krachtopnemers: Stretchpatch | Type: ST2200-PT', value: this.getValue('conformiteit_krachtopnemers')}),
						'conformiteit_software_versie': this.input({type: 'YesNo', label: `Softwareversie : ${this.softwareVersion}`, value: this.getValue('conformiteit_software_versie')}),
						'conformiteit_checksum': this.input({type: 'YesNo', label: `Checksum : ${this.checksum}`, value: this.getValue('conformiteit_checksum')}),
            'conformiteit_seal_number': this.input({type: 'Number', label: 'Zegelnr : ', value: this.getValue('conformiteit_seal_number')}),
					}
				},
				{
					'title': 'Algemeen',
					'name': 'common',
					'component': 'default',
					'values': {
						'common_omgevingstemperatuur': this.input({type: 'YesNo', label: 'Omgevingstemperatuur', value: this.getValue('common_omgevingstemperatuur')}),
						'common_nl_handleiding': this.input({type: 'YesNo', label: 'NL handleiding en NL opschriften', value: this.getValue('common_nl_handleiding')}),
						'common_voedingsspanning': this.input({type: 'YesNo', label: 'Voedingsspanning', value: this.getValue('common_voedingsspanning')}),
						'common_electronische_mechanische_werking': this.input({type: 'YesNo', label: 'Electronische / mechanische werking', value: this.getValue('common_electronische_mechanische_werking')}),
						'common_optische_controle': this.input({type: 'YesNo', label: 'Optische controle krachtopn. / platen / lagers', value: this.getValue('common_optische_controle')}),
					}
				},
        {
          'title': 'Remmentest',
          'name': 'remmentest',
          'component': 'remmentest',
          'values': {
            'remmentest_50_dan_left' : this.input({label: '50', value: this.getValue('remmentest_50_dan_left'), testValue: 50, callback: this.isWithinMargin}),
            'remmentest_50_dan_right' : this.input({label: '50', value: this.getValue('remmentest_50_dan_right'), testValue: 50, callback: this.isWithinMargin}),
            'remmentest_100_dan_left' : this.input({label: '100', value: this.getValue('remmentest_100_dan_left'), testValue: 100, callback: this.isWithinMargin}),
            'remmentest_100_dan_right' : this.input({label: '100', value: this.getValue('remmentest_100_dan_right'), testValue: 100, callback: this.isWithinMargin}),
            'remmentest_200_dan_left' : this.input({label: '200', value: this.getValue('remmentest_200_dan_left'), testValue: 200, callback: this.isWithinMargin}),
            'remmentest_200_dan_right' : this.input({label: '200', value: this.getValue('remmentest_200_dan_right'), testValue: 200, callback: this.isWithinMargin}),
            'remmentest_300_dan_left' : this.input({label: '300', value: this.getValue('remmentest_300_dan_left'), testValue: 300, callback: this.isWithinMargin}),
            'remmentest_300_dan_right' : this.input({label: '300', value: this.getValue('remmentest_300_dan_right'), testValue: 300, callback: this.isWithinMargin}),
            'remmentest_400_dan_left' : this.input({label: '400', value: this.getValue('remmentest_400_dan_left'), testValue: 400, callback: this.isWithinMargin}),
            'remmentest_400_dan_right' : this.input({label: '400', value: this.getValue('remmentest_400_dan_right'), testValue: 400, callback: this.isWithinMargin}),
            'remmentest_500_dan_left' : this.input({label: '500', value: this.getValue('remmentest_500_dan_left'), testValue: 500, callback: this.isWithinMargin}),
            'remmentest_500_dan_right' : this.input({label: '500', value: this.getValue('remmentest_500_dan_right'), testValue: 500, callback: this.isWithinMargin}),
            'remmentest_600_dan_left' : this.input({label: '600', value: this.getValue('remmentest_600_dan_left'), testValue: 600, callback: this.isWithinMargin}),
            'remmentest_600_dan_right' : this.input({label: '600', value: this.getValue('remmentest_600_dan_right'), testValue: 600, callback: this.isWithinMargin}),
            'remmentest_700_dan_left' : this.input({label: '700', value: this.getValue('remmentest_700_dan_left'), testValue: 700, callback: this.isWithinMargin}),
            'remmentest_700_dan_right' : this.input({label: '700', value: this.getValue('remmentest_700_dan_right'), testValue: 700, callback: this.isWithinMargin}),
            'remmentest_800_dan_left' : this.input({label: '700', value: this.getValue('remmentest_800_dan_left'), testValue: 800, callback: this.isWithinMargin}),
            'remmentest_800_dan_right' : this.input({label: '700', value: this.getValue('remmentest_800_dan_right'), testValue: 800, callback: this.isWithinMargin}),
            'remmentest_900_dan_left' : this.input({label: '900', value: this.getValue('remmentest_900_dan_left'), testValue: 900, callback: this.isWithinMargin}),
            'remmentest_900_dan_right' : this.input({label: '900', value: this.getValue('remmentest_900_dan_right'), testValue: 900, callback: this.isWithinMargin}),
          },
        },
				{
					'name': 'slot',
					'component': 'default',
					'values': {
						'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
					}
				}
			]
		}
	}
}
</script>

<template>
	<FormRenderer
		ref="renderer"
		:inspectionReport="inspectionReport"
		:inspectionReportResponse="inspectionReportResponse"
		:customerProduct="customerProduct"
		:appointmentId="appointmentId"
	/>
</template>